"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioTab_1 = require("./RadioTab");
exports.default = RadioTab_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RadioTab/index.js
// module id = 1268
// module chunks = 8